import { wsService } from "./wsService";

const section = "picking-details";

const STATUS_PENDIENTE = "P";
const STATUS_COMPLETADO_PARCIAL = "CP";
const STATUS_COMPLETADO = "C";
const STATUS_CANCELADO = "X";

const STATUS_NAME_PENDIENTE = "Pendiente";
const STATUS_NAME_COMPLETADO_PARCIAL = "Completado Parcial";
const STATUS_NAME_COMPLETADO = "Completado";
const STATUS_NAME_CANCELADO = "Cancelado";

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function get(param = { enable: true }) {
  return wsService.make_post_request(section + "/get", param);
}

function list_status() {
  return wsService.make_get_request(section + "/list_status");
}

function getStatusName(status) {
  const statusMap = {
    [pickingDetailService.STATUS_PENDIENTE]: pickingDetailService.STATUS_NAME_PENDIENTE,
    [pickingDetailService.STATUS_COMPLETADO_PARCIAL]: pickingDetailService.STATUS_NAME_COMPLETADO_PARCIAL,
    [pickingDetailService.STATUS_COMPLETADO]: pickingDetailService.STATUS_NAME_COMPLETADO,
    [pickingDetailService.STATUS_CANCELADO]: pickingDetailService.STATUS_NAME_CANCELADO,
  };
  return statusMap[status] || "Desconocido";
}

export const pickingDetailService = {
  section,
  STATUS_PENDIENTE,
  STATUS_COMPLETADO_PARCIAL,
  STATUS_COMPLETADO,
  STATUS_CANCELADO,
  STATUS_NAME_PENDIENTE,
  STATUS_NAME_COMPLETADO_PARCIAL,
  STATUS_NAME_COMPLETADO,
  STATUS_NAME_CANCELADO,
  getStatusName,
  filter,
  remove,
  create,
  update,
  get,
  list_status,
};
